exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed[data-v-01a8b9b0]{position:fixed;top:0}", ""]);

// exports
